"use client";

import { usePathname } from "next/navigation";

// Shows the address that failed, so a typo is easy to spot.
export function RequestedPath() {
  const pathname = usePathname();
  if (!pathname || pathname === "/") return null;
  return (
    <p className="mt-4 text-[0.9375rem] text-paper">
      You asked for{" "}
      <code className="break-all rounded-[3px] bg-cocoa px-1.5 py-0.5 font-mono text-[0.875rem] text-paper">{pathname}</code>
    </p>
  );
}
